import { PreHangOption } from "@/types/preHang"

export class Common {

    public static getJambMaterial(speciesName: string|null): string {
        return !speciesName ?
            'Primed' :
            speciesName.toLowerCase().indexOf('pine') !== -1 ?
                'Clear Pine' :
                speciesName.toLowerCase().indexOf('alder') !== -1 ?
                    'Select Alder' :
                    speciesName
    }

    /**
     * Builds measurement options based on sixteenths.
     * @param start Starting measurement in sixteenths. (i.e. 3" = 48 sixteenths)
     * @param end Ending measurement in sixteenths. (i.e. 5-1/2" = 88 sixteenths)
     * @param categoryId Category Identifier. Based on Pricing data in Pricing API
     * @returns
     */
    public static createMeasurementOptionsBySixteenths(start: number | string, end: number | string, categoryId: number): PreHangOption[] {
        const startNum: number = (typeof start == 'string') ? this.countSixteenths(start) : start
        const endNum: number = (typeof end == 'string') ? this.countSixteenths(end) : end
        const options: PreHangOption[] = []

        for(let i=startNum; i <= endNum; i++) {
            const integer = Math.floor(i / 16)
            const numerator = i % 16
            const divider = this.getDivider(numerator)
            
            let display = ''
            if(integer > 0) display = `${integer}`
            if(integer > 0 && numerator > 0) display += '-'
            if(numerator > 0) display += `${numerator/divider}/${16/divider}`  
            
            options.push({
                id: i,
                name: display,
                preHangCategoryId: categoryId,
                price: 0
            })
        }

        return options
    }

    /**
     * Converts measurements written as a string to a count of sixteenths of an inch
     * @param width string, inches i.e '4-3/8' or '2' or '1/4'
     * @returns 
     */
    public static countSixteenths(width: string):number {
        let int = 0 // integer value
        let frac = 0 // fraction value
        let fraction = width
        if(width.includes('-') || !width.includes('/')) {
            const widthSplit = width.split('-')
            int = parseInt(widthSplit[0]) * 16
            fraction = widthSplit[1]
        }
        if(fraction) {
            const fractionSplit = fraction.split('/')
            frac = (parseInt(fractionSplit[0]) / parseInt(fractionSplit[1])) * 16  
        }
        
        return int + frac
    }

    private static getDivider(numerator: number) {
        let result = 1
        let divider = 2
        while(numerator >= divider && numerator % divider == 0) {
            result = divider
            divider = divider * 2
        }
        return result
    }
}
